import React from "react";
import { FormattedMessage } from "react-intl";
import { useNavigate, useLocation } from "react-router";
import classes from "./MyProfileHeadingAndTabs.module.scss";

const MyProfileHeadingAndTabs = ({
  children,
  assignedType,
  setAssignedType,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  // const [myProfile, setmyProfile] = useState(second);
  // const [changePwd, setchangePwd] = useState(second);
  // const [contactUs, setcontactUs] = useState(second)
  const tenantType = localStorage.getItem("SecurityProviderName");

  return (
    <div className={classes.myProfileHeadingAndTabsPage}>
      <div className={classes.myProfileHeadingAndTabsPage__myProfileInnerDiv}>
        <h1
          className={
            classes.myProfileHeadingAndTabsPage__myProfileInnerDiv__subHeaderLeftHeading
          }
        >
          {location.pathname ===
            `/${localStorage.getItem("tenantName")}/userProfile/myProfile` && (
            <FormattedMessage id="MY_PROFILE_TEXT" />
          )}
          {!(tenantType == "aad") &&
            location.pathname ===
              `/${localStorage.getItem(
                "tenantName"
              )}/userProfile/changePassword` && (
              <FormattedMessage id="MY_PROFILE_CHANGE_PWD__TEXT" />
            )}

          {location.pathname ===
            `/${localStorage.getItem("tenantName")}/userProfile/contactUs` && (
            <FormattedMessage id="CONTACTUS_HEADER" />
          )}
        </h1>
        <div
          className={
            classes.myProfileHeadingAndTabsPage__myProfileInnerDiv__subHeaderRightTabs
          }
        >
          <div
            className={`${classes.tabsLinks} ${
              location.pathname ===
              `/${localStorage.getItem("tenantName")}/userProfile/myProfile`
                ? classes.typeList__active
                : ""
            }`}
            onClick={() => {
              navigate(
                `/${localStorage.getItem("tenantName")}/userProfile/myProfile`
              );
            }}
          >
            <FormattedMessage id="MY_PROFILE_TEXT" />
          </div>
          {!(tenantType == "aad" || tenantType == "SAML2") && (
            <div
              className={
                location.pathname ===
                `/${localStorage.getItem(
                  "tenantName"
                )}/userProfile/changePassword`
                  ? classes.typeList__active
                  : classes.tabsLinks
              }
              onClick={() => {
                navigate(
                  `/${localStorage.getItem(
                    "tenantName"
                  )}/userProfile/changePassword`
                );
              }}
            >
              <FormattedMessage id="MY_PROFILE_CHANGE_PWD__TEXT" />
            </div>
          )}

          <div
            className={
              location.pathname ===
              `/${localStorage.getItem("tenantName")}/userProfile/contactUs`
                ? classes.typeList__active
                : classes.tabsLinks
            }
            onClick={() => {
              navigate(
                `/${localStorage.getItem("tenantName")}/userProfile/contactUs`
              );
            }}
          >
            <FormattedMessage id="CONTACTUS_HEADER" />
          </div>
        </div>
      </div>
      <div className={classes.allChildren}>{children}</div>
    </div>
  );
};

export default MyProfileHeadingAndTabs;
